import React, { useState, useEffect } from "react";
import Layout from "../../Components/Layout";
import "./people.css";

const teamMembers = [
  {
    name: "Bubble",
    title: "Founder CEO",
    photo: "/img/bubble-boi.jpg",
    photoOffset: { offsetX: -600, offsetY: -50 } // custom offsets for Bubble Boi
  },
  {
    name: "Drew" ,
    title: "Co-founder CTO",
    photo: "/img/drew.jpg",
    photoOffset: { offsetX: -600, offsetY: -50 } // custom offsets for Drew
  },
  {
    name: "Dr. Kim",
    title: "Scientific Advisor",
    photo: "/img/dr-kim.jpg",
    photoOffset: { offsetX: -600, offsetY: -50 } // custom offsets for Dr. Kim
  }
];

const People = () => {
  const [hoveredPerson, setHoveredPerson] = useState(null);
  const [photoStyle, setPhotoStyle] = useState(null);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 600);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 500);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Handle name click on small screens
  const handleNameClick = (member) => {
    if (isSmallScreen) {
      setHoveredPerson(member);
      // For mobile, you might want to center or use a modal instead.
      setPhotoStyle(null);
    }
  };

  // Handle image click to close popup on small screens
  const handleImageClick = () => {
    if (isSmallScreen) {
      setHoveredPerson(null);
      setPhotoStyle(null);
    }
  };

  // Replace your existing handleMouseEnter with this version:
  const handleMouseEnter = (member, event) => {
    if (!isSmallScreen) {
      // Get the bounding rectangle of the row and the container.
      const rowRect = event.currentTarget.getBoundingClientRect();
      const container = document.querySelector(".textContainer");
      const containerRect = container.getBoundingClientRect();
      
      // Define default offsets
      const defaultOffsetX = -650; 
      const defaultOffsetY = -100;
      
      // Use member-specific offsets if they exist
      const offsetX = member.photoOffset ? member.photoOffset.offsetX : defaultOffsetX;
      const offsetY = member.photoOffset ? member.photoOffset.offsetY : defaultOffsetY;
      
      // Calculate the image's position relative to the container.
      const photoLeft = rowRect.right - containerRect.left + offsetX;
      const photoTop = rowRect.top - containerRect.top + offsetY;
      
      setHoveredPerson(member);
      setPhotoStyle({
        position: "absolute",
        left: photoLeft + "px",
        top: photoTop + "px",
        backgroundImage: `url(${member.photo})`,
        backgroundSize: "cover",
        width: "200px",  // adjust dimensions as needed
        height: "200px",
        zIndex: 10,
      });
    }
  };

  // When the mouse leaves, clear the hovered person and photo style
  const handleMouseLeave = () => {
    if (!isSmallScreen) {
      setHoveredPerson(null);
      setPhotoStyle(null);
    }
  };

  return (
    <Layout>
      <main className="wrapper" style={{ position: "relative" }}>
        <div
          className="textContainer"
          onClick={hoveredPerson ? handleImageClick : undefined}
        >
          <div>
            <br />
            <h2>Our Team</h2>
            <p>Meet the brilliant minds behind Bubble Computing:</p>

            <div>
              <div className="teamList">
                <table
                  style={{
                    borderSpacing: "0 1rem",
                    borderCollapse: "separate",
                  }}
                >
                  <tbody>
                    {teamMembers.map((member, index) => (
                      <tr
                        key={index}
                        onClick={() => handleNameClick(member)}
                        onMouseEnter={(e) => handleMouseEnter(member, e)}
                        onMouseLeave={handleMouseLeave}
                        style={{ cursor: "pointer" }}
                      >
                        <td style={{ paddingRight: "2rem" }}>{member.name}</td>
                        <td>{member.title}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {/* Render overlay image only for larger screens when hovered */}
              {hoveredPerson && !isSmallScreen && photoStyle && (
                <div className="photo" style={photoStyle} />
              )}
              {/* For small screens, you can use a modal or different layout */}
              {hoveredPerson && isSmallScreen && (
                <div className="popup">
                  <div className="popupContent">
                    <img
                      src={hoveredPerson.photo}
                      alt={hoveredPerson.name}
                      style={{ maxWidth: "100%", height: "auto" }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
};

export default People;
